"use client";
import * as r from "react";
import { u as m } from "./useId-CFOlRH4L.mjs";
import { u as p } from "./useIsoLayoutEffect-DpJo20by.mjs";
import { j as i } from "./jsx-runtime-CJ-St4mQ.mjs";
function N() {
  const n = /* @__PURE__ */ new Map();
  return {
    emit(t, e) {
      var o;
      (o = n.get(t)) == null || o.forEach((s) => s(e));
    },
    on(t, e) {
      n.has(t) || n.set(t, /* @__PURE__ */ new Set()), n.get(t).add(e);
    },
    off(t, e) {
      var o;
      (o = n.get(t)) == null || o.delete(e);
    }
  };
}
const d = /* @__PURE__ */ r.createContext(null);
process.env.NODE_ENV !== "production" && (d.displayName = "FloatingNodeContext");
const u = /* @__PURE__ */ r.createContext(null);
process.env.NODE_ENV !== "production" && (u.displayName = "FloatingTreeContext");
const l = () => {
  var n;
  return ((n = r.useContext(d)) == null ? void 0 : n.id) || null;
}, x = () => r.useContext(u);
function E(n) {
  const t = m(), e = x(), s = l();
  return p(() => {
    if (!t)
      return;
    const a = {
      id: t,
      parentId: s
    };
    return e == null || e.addNode(a), () => {
      e == null || e.removeNode(a);
    };
  }, [e, t, s]), t;
}
function I(n) {
  const {
    children: t,
    id: e
  } = n, o = l();
  return /* @__PURE__ */ i.jsx(d.Provider, {
    value: r.useMemo(() => ({
      id: e,
      parentId: o
    }), [e, o]),
    children: t
  });
}
function v(n) {
  const {
    children: t
  } = n, e = r.useRef([]), o = r.useCallback((c) => {
    e.current = [...e.current, c];
  }, []), s = r.useCallback((c) => {
    e.current = e.current.filter((f) => f !== c);
  }, []), [a] = r.useState(() => N());
  return /* @__PURE__ */ i.jsx(u.Provider, {
    value: r.useMemo(() => ({
      nodesRef: e,
      addNode: o,
      removeNode: s,
      events: a
    }), [o, s, a]),
    children: t
  });
}
export {
  I as F,
  l as a,
  v as b,
  N as c,
  E as d,
  x as u
};
